import {Button} from "antd";
import {Link} from "react-router-dom";
import styles from "./cookieConsentBanner.module.less";

type CookieConsentBannerProps = {
    onAccept: () => void;
    onReject: () => void;
};

export default function CookieConsentBanner({onAccept, onReject}: CookieConsentBannerProps) {
    return (
        <div className={styles.banner} role="region" aria-live="polite" aria-label="Zgoda na pliki cookies">
            <div className={styles.content}>
                <p className={styles.title}>Pliki cookies</p>
                <p className={styles.description}>
                    Używamy niezbędnych cookies do działania serwisu oraz opcjonalnych cookies analitycznych.
                    Możesz zaakceptować wszystkie albo pozostać tylko przy niezbędnych.{" "}
                    <Link className={styles.link} to="/privacy">
                        Polityka prywatności
                    </Link>
                </p>
            </div>
            <div className={styles.actions}>
                <Button onClick={onReject}>
                    Tylko niezbędne
                </Button>
                <Button type="primary" onClick={onAccept}>
                    Akceptuję
                </Button>
            </div>
        </div>
    );
}
